import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { XSolid } from '../../../icons/x-solid';
import { style } from './style';

type HistoryHeaderProps = {
  onCloseClick: () => void,
  entityName: string,
}
export const HistoryHeader = ({
  onCloseClick,
  entityName,
} : HistoryHeaderProps):JSX.Element => {
  return (
    <Box
      sx={ style.card.headerRow }
      onClick={ onCloseClick }
    >
      <Typography variant="h6">
        {entityName}
      </Typography>
      <Button
        sx={ {
          px: 0,
        } }
        color="inherit"
      >
        <XSolid
          fill="#fff"
        />
      </Button>
    </Box>
  );
};
